// extracted by mini-css-extract-plugin
export default {"investor-selection":"navigation_investor-selection__UU5dJ","user":"navigation_user__SKKzT"};